const quota_table = {
    quota: {
        title: 'Cơ bản',
        base_price: 'Giá cơ bản',
        mau_limit: 'Giới hạn MAU',
        included_tokens: 'Token bao gồm',
    },
    application: {
        title: 'Ứng dụng',
        total: 'Tổng số ứng dụng',
        m2m: 'Ứng dụng máy tới máy',
        third_party: 'Ứng dụng bên thứ ba OIDC/OAuth',
        saml_app: 'Ứng dụng SAML',
    },
    resource: {
        title: 'Tài nguyên API',
        resource_count: 'Số lượng tài nguyên',
        scopes_per_resource: 'Quyền theo mỗi tài nguyên',
    },
    branding: {
        title: 'Giao diện và nhận diện thương hiệu',
        custom_domain: 'Domain tùy chỉnh',
        custom_css: 'CSS tùy chỉnh',
        logo_and_favicon: 'Logo và favicon',
        bring_your_ui: 'Dùng giao diện riêng',
        dark_mode: 'Chế độ tối',
        i18n: 'Đa ngôn ngữ',
    },
    user_authn: {
        title: 'Xác thực người dùng',
        omni_sign_in: 'Đăng nhập đa kênh',
        password: 'Mật khẩu',
        passwordless: 'Không mật khẩu - Email và SMS',
        email_connector: 'Liên kết email',
        sms_connector: 'Liên kết SMS',
        social_connectors: 'Liên kết mạng xã hội',
        standard_connectors: 'Liên kết chuẩn',
        built_in_email_connector: 'Liên kết email tích hợp',
        mfa: 'Xác thực đa yếu tố',
        sso: 'SSO doanh nghiệp',
        impersonation: 'Giả lập người dùng',
    },
    user_management: {
        title: 'Quản lý người dùng',
        user_management: 'Quản lý người dùng',
        roles: 'Vai trò',
        machine_to_machine_roles: 'Vai trò máy tới máy',
        scopes_per_role: 'Quyền theo mỗi vai trò',
    },
    organizations: {
        title: 'Tổ chức',
        organizations: 'Tổ chức',
        organization: 'Tổ chức',
        organization_count: 'Số lượng tổ chức',
        allowed_users_per_org: 'Số người dùng mỗi tổ chức',
        invitation: 'Lời mời (Management API)',
        org_roles: 'Vai trò tổ chức',
        org_permissions: 'Quyền tổ chức',
        just_in_time_provisioning: 'Cấp phát vừa kịp lúc (JIT)',
    },
    support: {
        title: 'Hỗ trợ',
        community: 'Cộng đồng',
        customer_ticket: 'Hỗ trợ qua ticket',
        premium: 'Cao cấp',
        email_ticket_support: 'Hỗ trợ ticket qua email',
        discord_private_channel: 'Kênh Discord riêng',
        premium_support: 'Hỗ trợ cao cấp',
        developer_onboarding: 'Hướng dẫn nhập môn cho nhà phát triển',
        solution_engineer_support: 'Kỹ sư giải pháp',
        sla: 'SLA',
        dedicated_computing_resources: 'Tài nguyên tính toán chuyên dụng',
    },
    compliance: {
        title: 'Tuân thủ',
        soc2_compliant: 'Đạt chuẩn SOC2',
        soc2_report: 'Báo cáo SOC2',
        hipaa_or_baa_report: 'Báo cáo HIPAA/BAA',
    },
    developers_and_platform: {
        title: 'Nhà phát triển và nền tảng',
        hooks: 'Webhook',
        audit_logs_retention: 'Thời gian lưu nhật ký kiểm tra',
        jwt_claims: 'Claim JWT',
        tenant_members: 'Thành viên tenant',
    },
    unlimited: 'Không giới hạn',
    contact: 'Liên hệ',
    monthly_price: '${{value, number}}/tháng',
    days: '{{count, number}} ngày',
    days_other: '{{count, number}} ngày',
    add_on: 'Tiện ích thêm',
    tier: 'Cấp {{value, number}}: ',
    million: '{{value, number}} triệu',
    mau_tip: 'MAU (người dùng hoạt động hàng tháng) là số người dùng duy nhất đã trao đổi ít nhất một token với sdvico trong một kỳ thanh toán.',
    tokens_tip: 'Tất cả các loại token do sdvico phát hành, bao gồm access token, refresh token, v.v.',
    mao_tip: 'MAO (tổ chức hoạt động hàng tháng) là số tổ chức duy nhất có ít nhất một MAU (người dùng hoạt động hàng tháng) trong một kỳ thanh toán.',
    third_party_tip: 'Dùng sdvico làm nhà cung cấp danh tính OIDC cho việc đăng nhập ứng dụng bên thứ ba và cấp quyền.',
    included: 'Bao gồm {{value, number}}',
    included_mao: 'Bao gồm {{value, number}} MAO',
    extra_quota_price: 'Sau đó ${{value, number}} mỗi tháng / mỗi đơn vị',
    extra_token_price: 'Sau đó ${{value, number}} mỗi tháng / {{amount, number}} sau đó',
    per_month_each: '${{value, number}} mỗi tháng / mỗi đơn vị',
    extra_mao_price: 'Sau đó ${{value, number}} mỗi MAO',
    per_month: '${{value, number}} mỗi tháng',
    per_member: 'Sau đó ${{value, number}} mỗi thành viên',
};
export default Object.freeze(quota_table);
